module.exports = __webpack_public_path__ + "img/fill.9efe7637.svg";